import { Layout, Typography } from 'antd';

import backgroundImage from '../house_main_picture.png'; // Import your background image
import hungary from '../icons/hungary_logo.jpg';
import logo from '../logo-transparent.png';
import logo1 from '../NARKS.png';
import logo2 from '../LRM.png';
import { useMediaQuery } from '@mui/material';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const LandingPageSection = () => {
    const isMobile = useMediaQuery('(max-width: 450px)');
    return (
        <Layout
        id="home"
            style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '70vh',
                width: '100%',
                padding: '1rem',
            }}
        >
            <Content style={{ textAlign: 'center', color: '#fff' }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        flexWrap: 'wrap',
                    }}
                >
                    <div
                        style={{
                            width: '100%',
                            padding: '20px',
                            flex: '1 1 100%',
                            display: 'none', // optional: hide this section if unused
                        }}
                    ></div>
                    {!isMobile  && <div style={{
                        width: '50%',
                    }} />}
                    <div
                        style={{
                            width: isMobile ? '100%' : '50%',
                            padding: '20px',
                            paddingLeft: isMobile ? '0' : '3rem',
                            // marginLeft: isMobile ? '0' : '1rem',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: isMobile ? 'center' : 'flex-start',
                            alignItems: 'flex-start',
                        }}
                    >
                        <Title
                            level={2}
                            style={{
                                textAlign: 'left',
                                fontSize: '2rem',
                                color: 'rgba(0,0,0,0.8)',
                            }}
                        >
                            {!isMobile && <img src={logo} alt="logo" style={{ width: '30rem', height: 'auto', marginBottom: '1rem' }} />}
                            
                            <span style={{
                                backgroundColor: isMobile ? 'rgb(155 139 75 / 66%)' : 'transparent',
                                color: isMobile ? 'white' : 'black',
                            }}>Váš spoľahlivý partner</span>
                            <br />
                            <span style={{
                                backgroundColor: isMobile ? 'rgb(155 139 75 / 66%)' : 'transparent',
                                color: isMobile ? 'white' : 'black',
                            }}>pre nehnuteľnosti</span>
                            <br />
                            <span style={{
                                backgroundColor: isMobile ? 'rgb(155 139 75 / 66%)' : 'transparent',
                                color: isMobile ? 'white' : 'black',
                                display: 'flex',
                                alignItems: 'center',
                            }}>v Maďarsku
                          <img src={hungary} alt="logo" 
                            style={{ height: '1.5rem', marginLeft: '0.5rem'}} />
                            </span>
                        </Title>
                        <Paragraph
                            style={{
                                textAlign: 'left',
                                fontSize: '1.2rem',
                                marginBottom: '1rem',
                                justifyContent: isMobile ? 'center' : 'flex-start',
                                alignItems: isMobile ? 'center' : 'flex-start', 
                            }}
                        >
                           <span style={{
                                backgroundColor: isMobile ? 'rgb(255 255 255 / 80%)' : 'transparent',
                                color: isMobile ? 'rgb(155 139 75 / 66%)'  : 'black',
                           }}>Objavte Maďarsko s Reality A&T – kde bývanie má štýl a investícia
                            zmysel.</span>
                        </Paragraph>
                        <a href="#all-listings">
                        <div style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start',
                            marginBottom: isMobile ? '1rem' : '0',
                         }}>
                            <button className="our-offer-button-new nice-button">
                                Zobraziť ponuky
                            </button>
                        </div>
                        </a>
                    </div>
                </div>
            </Content>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '1rem',
                    margin: '1rem 0 2rem 1rem',
                }}
            >
                <img src={logo1} alt="Logo 1" style={{ width: isMobile ? window.innerWidth * 0.18 : '80px' }} />
                <img src={logo2} alt="Logo 2" style={{ width: isMobile ? window.innerWidth * 0.18 : '80px' }} />
            </div>
        </Layout>
    );
}

export default LandingPageSection;
